exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-view-header {\n  background-color: #fff;\n  padding: 1.8em 2em 1em;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n.item-view-header h1 {\n  display: inline;\n  font-size: 1.5em;\n  margin: 0;\n  margin-right: 0.5em;\n}\n.item-view-header .host,\n.item-view-header .meta,\n.item-view-header .meta a {\n  color: #828282;\n}\n.item-view-header .meta a {\n  text-decoration: underline;\n}\n.item-view-comments {\n  background-color: #fff;\n  margin-top: 10px;\n  padding: 0 2em 0.5em;\n}\n.item-view-comments-header {\n  margin: 0;\n  font-size: 1.1em;\n  padding: 1em 0;\n  position: relative;\n}\n.item-view-comments-header .spinner {\n  display: inline-block;\n  margin: -15px 0;\n}\n.comment-children {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n@media (max-width: 600px) {\n.item-view-header h1 {\n    font-size: 1.25em;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/ItemView.vue?vue&type=style&index=0&lang=stylus&
// module id = 812
// module chunks = 1